import React from 'react';

const FileIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-file" data-testid="file-icon" />
    </div>
  );
};

export default FileIcon;
